<template>
    <div
        ref="avatar"
        class="avatar"
        :data-initials="initials"
        :style="{
            backgroundColor: colour,
            width: width + 'px',
            fontSize: fontWidth,
        }"
        v-b-tooltip.hover
        :title="name"
    ></div>
</template>

<script>
export default {
    props: {
        name: {
            required: true,
        },
        colour: {
            required: true,
        },
        width: {
            default: 70,
        },
    },
    data() {
        return {
            fontWidth: '',
        };
    },
    mounted() {
        this.fontWidth = this.$refs.avatar.clientWidth * 0.35 + 'px';
    },
    computed: {
        initials() {
            if (!this.name) {
                return 'N/A';
            } else {
                var initials = this.name
                    .split(' ')
                    .map(function(item) {
                        return item[0];
                    })
                    .join('');

                return initials;
            }
        },
    },
};
</script>

<style></style>
